import React from 'react'
import KeywordsFilterModule from './KeywordsFilterItems.module.scss'

const KeywordsFilterItems = ({ value, onChange }) => {
  return (
    <div className={KeywordsFilterModule['filter-container']}>
      <label>
        キーワード除外
        <input
          className={KeywordsFilterModule['keyword-input']}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        <p>※複数語を同時に除外する場合は、ワードごとに半角カンマ「,」で区切ってください</p>
      </label>
    </div>
  )
}

export default KeywordsFilterItems
